import React from 'react'

const OpKeywordBasic = ({ details }) => {
  if (!details.op_basic_active) {
    return null
  }

  return (
    <div className="setting-subsection">
      <div className="subsection-name">
        Basic Settings
      </div>
      <div className="setting-wrapper">
        Target ACoS:
        <span className="setting-value">{ details.target_acos }</span>
      </div>
      <div className="setting-wrapper">
        Min Clicks:
        <span className="setting-value">{ details.min_clicks }</span>
      </div>
      <div className="setting-wrapper">
        Min Impressions:
        <span className="setting-value">{ details.min_impressions }</span>
      </div>
      <div className="setting-wrapper">
        Lookback period (days):
        <span className="setting-value">{ details.op_lookback }</span>
      </div>
    </div>
  )
}

export default OpKeywordBasic
